module.exports = __webpack_public_path__ + "static/media/main.ab6aa18d.jpg";